import { useContext, useEffect, useState } from 'react'
import { CheckBoxButton } from './CheckBoxButton'
import { LoginContext } from './LoginOrSignUp'
import { PrimaryButton } from './PrimaryButton'
import { UnderLinedButton } from './UnderlinedButton'
import { OtpFields } from '../components/OtpFields'
import { Timer } from './Timer'
import useTranslation from '../hooks/useTranslation'
import classNames from 'classnames'
import { otpContinueHandler, resendOtpHandler, seekersAnalayticOptions } from '../utils/functions'
import { trackEvent, loginTrack } from '../analytics'
import { OtpFieldsNew } from '../components/OtpFieldsNew'
import { SharedContext } from '@/context/SharedContext'

export const OtpModal = () => {
  const [ischeckBoxClicked, setCheckBoxClicked] = useState(true)
  const [loading, setLoading] = useState(false)
  const [otpError, setOtpError] = useState({ isError: false, msg: '' })
  const [resendEnable, setResendEnble] = useState(false)
  const translation = useTranslation()
  const {
    setLoginDetails,
    otp,
    handleOtp,
    setChangeNumber,
    countryCode,
    handleOtpClose,
    handleModalClose,
    mobileNumber,
    loginDetails,
    location
  } = useContext(LoginContext)
  const { cookie, isOnline, setShowToast, utmParams } = useContext(SharedContext)

  const numberOfOtpFields = 4

  const handleCheckBox = () => {
    setCheckBoxClicked((prv) => !prv)
  }

  const changeNumber = () => {
    trackEvent({
      name: 'seeker_change_login_number',
      searchParams: {
        ...utmParams
      },
      options: seekersAnalayticOptions(window, loginDetails, location, 'tap', 'seeker_login_page'),
      isSeeker: true
    })
    handleOtpClose()
    setChangeNumber(true)
  }

  const onTimerComplete = () => {
    setResendEnble(true)
  }

  useEffect(() => {
    setLoginDetails((prv) => ({
      ...prv,
      whatsAppOptIn: ischeckBoxClicked
    }))
  }, [ischeckBoxClicked])

  useEffect(() => {
    if (otp?.length != numberOfOtpFields && otpError?.isError) setOtpError(false)
  }, [otp])

  return (
    <div className="animate-slide">
      <div className="px-[12px] font-noto-sans">
        <div className="text-xl font-bold leading-22 text-black">{translation?.checkYourSms}</div>
        <div className="mt-sm text-base font-normal leading-22 text-darkGray">
          <div>
            {translation?.weHaveSentYouAnOtpOn} +{countryCode?.current}
            {mobileNumber}
          </div>
          <UnderLinedButton {...{ title: translation?.changeNumber, onClick: changeNumber }} />
        </div>
        <div className="mt-xl items-center ">
          <div className="text-sm font-normal leading-16 text-darkGray">
            {translation?.enterFourDigitOtp}
          </div>
          <div className="mt-sm">
            <OtpFieldsNew
              id="seekerMobile"
              clearData={otp?.length <= 0}
              onChange={handleOtp}
              inputClassName={classNames('h-[40px] w-[47.96px]')}
              setOtpError={setOtpError}
            />
            {otpError?.isError && (
              <div className="mt-sm text-sm font-normal leading-16 text-error">{otpError?.msg}</div>
            )}
          </div>
          <div className="mt-lg flex text-base font-normal leading-[19.07px] text-lightGray">
            {translation?.didNotRecieveTheOtp}?
            <div className="flex space-x-[3px] font-bold text-[#97989B]">
              <UnderLinedButton
                {...{
                  title: resendEnable ? translation?.resendOtp : translation?.resendOtpIn,
                  className: 'ml-[2px]',
                  isClickEnabled: resendEnable,
                  onClick: () => {
                    resendOtpHandler({
                      setOtp: handleOtp,
                      isOnline,
                      setShowToast,
                      mobileNumber,
                      setOtpError,
                      setResendEnble,
                      trackEvent,
                      utmParams,
                      isSeeker: true
                    })
                    trackEvent({
                      name: 'seeker_resend_OTP',
                      searchParams: {
                        ...utmParams
                      },
                      options: seekersAnalayticOptions(
                        window,
                        { mobileNumber },
                        location,
                        'tap',
                        'seeker_login_page'
                      ),
                      isSeeker: true
                    })
                  }
                }}
              />

              {!resendEnable && <Timer onComplete={onTimerComplete} />}
            </div>
          </div>
          <div className="mt-exlg flex items-center" onClick={handleCheckBox}>
            <CheckBoxButton
              disabled={loading}
              className="h-[18px] w-[18px] accent-primary"
              isClicked={ischeckBoxClicked}
            />
            <div className="ml-sm text-sm font-normal leading-[16.34px] text-black">
              {translation?.otpCheckBoxDiscription}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2xl p-sm pb-[12.72px] shadow-primaryButton">
        <PrimaryButton
          {...{
            title: translation?.done,
            disabled: otp?.length != 4,
            onClick: () => {
              otpContinueHandler({
                setLoading,
                setOtpError,
                translation,
                handleOtp,
                setLoginDetails,
                ischeckBoxClicked,
                handleModalClose: (isLoggedIn) => {
                  handleOtpClose()
                  handleModalClose(isLoggedIn)
                },
                cookie,
                isOnline,
                setShowToast,
                mobileNumber,
                otp,
                trackEvent,
                loginTrack,
                utmParams,
                isSeeker: true,
                loginDetails,
                location
              })
              trackEvent({
                name: 'seeker_login_initiated',
                searchParams: {
                  ...utmParams
                },
                options: seekersAnalayticOptions(
                  window,
                  { mobileNumber },
                  location,
                  'tap',
                  'seeker_login_page'
                ),
                isSeeker: true
              })
            },
            loading
          }}
        />
      </div>
    </div>
  )
}
